import GoalStatisticsScreen from "./GoalStatisticsScreen"
export default GoalStatisticsScreen
